import { Auth } from 'aws-amplify';
import { put, takeEvery } from "redux-saga/effects";
import { publicIpv4 } from 'public-ip';
import i18n from 'i18next';
// Login Redux States
import { LOGIN_USER, LOGIN_USER_GLORIA, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess } from "./actions";

import service from '../../../api/login.service';
import serviceMonitor from '../../../api/monitor.service';
import serviceSupplier from '../../../api/supplier.service';
import dictionary from "../../../config/dictionary"

function* loginUserGloria() {
  try {
    const response = yield service.login();

    const ip = yield publicIpv4();
    let name = '';
    if (response.signInUserSession.idToken.payload.given_name !== undefined) {
      name = response.signInUserSession.idToken.payload.given_name + ' ' + response.signInUserSession.idToken.payload.family_name;
    } else {
      name = response.signInUserSession.idToken.payload.email;
    }

    let json = {
      cognitoId: response.username,
      username: response.username,
      email: response.username,
      sessionIp: ip,
      name: name,
      codeSystem: process.env.REACT_APP_SYSTEM_CODE,
      registerLog: true,
      isRegister: '1',
      roleCode: process.env.REACT_APP_ROL_SUPERVISOR_CODE
    };
    yield setRol(json);

    yield put(loginSuccess(response));

    return response;

  } catch (error) {
    yield put(apiError(error.message));
  }
}

function* loginUser({ payload: { user } }) {
  try {

    const response = yield service.loginCognito(user.email, user.password);
    const responseUser = yield serviceMonitor.getUserActive({ username: user.email });
    if (!responseUser.data) {
      yield put(apiError(i18n.t("authentication:errorUser")));
      yield logoutSessionAD();
    } else {
      const ip = yield publicIpv4();
      let json = {
        cognitoId: user.email,
        username: response.username,
        email: user.email,
        sessionIp: ip,
        name: user.fullname,
        codeSystem: process.env.REACT_APP_SYSTEM_CODE,
        registerLog: true,
        isRegister: '1',
        roleCode: process.env.REACT_APP_ROL_PROVIDER_CODE
      };

      yield setRol(json);
      yield put(loginSuccess(response));
      return response;
    }
  } catch (error) {
    yield put(apiError(error.message));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    let json = {
      username: sessionStorage.getItem('username'),
      codeSystem: process.env.REACT_APP_SYSTEM_CODE,
      registerLog: true,
    };
    yield service.logout(json).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield logoutSessionAD();
    window.location.href = '/login';
  } catch (error) {
    yield put(apiError(error));
    yield logoutSessionAD();
    window.location.href = '/login';
  }
}
const logoutSessionAD = function* () {
  try {
    yield window.sessionStorage.removeItem('username');
    yield window.sessionStorage.removeItem('name');
    yield window.sessionStorage.removeItem('user');
    yield window.sessionStorage.removeItem('menu');
    yield window.sessionStorage.removeItem('token');
    yield window.sessionStorage.removeItem('node');
    yield window.sessionStorage.removeItem('menuId');
    yield removeSession();
  } catch (error) {
    yield removeSession();
  }
}

const removeSession = function* () {
  yield Auth.signOut();
}

async function setRol(jsonLogin) {
  await service.registerUser(jsonLogin);

  if (jsonLogin.isRegister === '1') {
    const jsonRole = {
      roleCode: jsonLogin.roleCode,
      username: jsonLogin.username,
    }

    await service.registerRole(jsonRole);
  }
  const response = await service.getDataUser(jsonLogin).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });
  if (response.error === undefined) {
    await registerUserData(response)
    window.sessionStorage.removeItem('errorSession');
    sessionStorage.setItem('user', JSON.stringify(response.rol));
    sessionStorage.setItem('menu', JSON.stringify(response.menu));
  } else {
    sessionStorage.setItem('errorSession', JSON.stringify(response));
  }
}

async function registerUserData({ rol, user }) {
  try {
    const json = {
      positionWork: rol.id.role.name,
      name: user.name,
      username: user.username,
      society: process.env.REACT_APP_STYLE_TEMPLATE,
      state: "1",
      email: user.email,
      phone: user.phone,
      codeType: user.name ? dictionary.configApp.type.codeTypeAD :
        dictionary.configApp.type.codeTypeCOGNITO
    };
    await serviceSupplier.saveSupplier(json);
  }
  catch (error) {
    put(apiError(error.message));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER_GLORIA, loginUserGloria);
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
